import React, { useState, useEffect } from "react";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "assets/svgIcons/AccordionExpandMoreIcon";
import CustomizedCheckbox from "commonComponents/FormElement/Checkbox";
import {
    getFeatureSetOption,
    getFeaturesList,
    isUserBasic,
    isUserReadOnly
} from "../../../../constant";
import _ from "lodash";
import { useTranslation } from "react-i18next";
import {
    Heading,
    WorkSection,
    CheckBoxWrapper,
    ActionWrapper,
    StartEndDate,
    DateWrapper
} from "pages/Fleet/Settings/SettingsStyled";
import { Loader } from "commonComponents/Loader/Loader";
import { useHookstate } from "@hookstate/core";
import { CenteredLoader } from "commonComponents/FormElement/Checkbox/CheckboxStyled";
import {
    FLEET_GLOBAL_STATES,
    SITEID_GLOBAL_STATE,
    CHECKBOX_LOADER
} from "globalStore/globalStore";
import { useDispatch, useSelector } from "react-redux";
import { Button } from "@mui/material";
import "react-quill/dist/quill.snow.css";
import { COMMON_SERVICES } from "redux/reduxToolkitServices/_commonServices/commonServices";
import { MobileTimePicker } from "@mui/x-date-pickers/MobileTimePicker";
import TextField from "@mui/material/TextField";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import TimeIcon from "assets/svgIcons/TimeIcon";

export const OffPeakChargingAccordion = ({ offPeakCharging,
    setOffPeakCharging
}) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();

    const { siteId } = useHookstate(SITEID_GLOBAL_STATE);

    const { PeakCharginLoader } = useHookstate(CHECKBOX_LOADER);

    const { enableDisablePeekChargingState } = useHookstate(FLEET_GLOBAL_STATES);

    const { siteSettingsData, getUserRole, getSiteOffPeakCharginData } = useSelector((state) => state?.commonReducers) || [];

    const [offPeakSaveButton, setOffPeakSaveButton] = useState(false);
    const [offPeakValidationMessage, setOffPeakValidationMessage] = useState("");

    useEffect(() => {
        if (getSiteOffPeakCharginData && Object.keys(getSiteOffPeakCharginData)?.length > 0) {
            if (getSiteOffPeakCharginData?.StartMinutes != null && getSiteOffPeakCharginData?.EndMinutes != null) {
                let starDate = new Date(2000, 0, 1, 0, 0, 0);
                starDate.setMinutes(getSiteOffPeakCharginData?.StartMinutes);
                let endDate = new Date(2000, 0, 1, 0, 0, 0);
                endDate.setMinutes(getSiteOffPeakCharginData?.EndMinutes);

                setOffPeakCharging({
                    ...offPeakCharging,
                    opcEnableLockdown: getSiteOffPeakCharginData?.IsEnabled,
                    opcStartTime: starDate,
                    opcEndTime: endDate
                });
            }

            enableDisablePeekChargingState.set(getSiteOffPeakCharginData?.IsEnabled);
        }
    }, [getSiteOffPeakCharginData]);

    const cancelPeakChargingFunc = () => {
        setOffPeakSaveButton(false);
        setOffPeakCharging({
            ...offPeakCharging,
            opcEnableLockdown: getSiteOffPeakCharginData?.IsEnabled,
            opcStartTime: new Date(2000, 0, 1, 0, getSiteOffPeakCharginData?.StartMinutes, 0),
            opcEndTime: new Date(2000, 0, 1, 0, getSiteOffPeakCharginData?.EndMinutes, 0),
        });
        enableDisablePeekChargingState.set(getSiteOffPeakCharginData?.IsEnabled);
    }


    const handleOpcStartTime = (time) => {
        if (time > offPeakCharging.opcEndTime) {
            setOffPeakValidationMessage("Start time is after End time")
            setOffPeakSaveButton(false);
        } else {
            if (offPeakValidationMessage != "")
                setOffPeakValidationMessage("");

            setOffPeakSaveButton(true);
        }

        setOffPeakCharging({
            ...offPeakCharging,
            opcStartTime: time
        });
    }

    const handleOpcEndTime = (time) => {
        if (time < offPeakCharging.opcStartTime) {
            setOffPeakValidationMessage("End time is before Start time");
            setOffPeakSaveButton(false);
        } else {
            if (offPeakValidationMessage != "")
                setOffPeakValidationMessage("");

            setOffPeakSaveButton(true);
        }

        setOffPeakCharging({
            ...offPeakCharging,
            opcEndTime: time
        });
    }

    const handleOffPeakCharging = () => {
        if (offPeakValidationMessage != "") {
            return;
        }

        setOffPeakSaveButton(false);

        var sm = offPeakCharging.opcStartTime.getHours() * 60 + offPeakCharging.opcStartTime.getMinutes();
        var em = offPeakCharging.opcEndTime.getHours() * 60 + offPeakCharging.opcEndTime.getMinutes();

        const payload = {
            IsEnabled: enableDisablePeekChargingState.value,
            StartMinutes: sm,
            EndMinutes: em,
            AllowOpportunityCharging: offPeakCharging.allowOpportunityCharging,
        };
        PeakCharginLoader.set(true);

        dispatch(
            COMMON_SERVICES.putSiteOffPeakChargingServices(payload, siteId.get())
        ).then(() => {
            PeakCharginLoader.set(false);
        });
    }

    return (
        <>
            <Accordion>
                <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel1a-content"
                    id="panel1a-header"
                >
                    <Heading>
                        <h3>{t("Off_Peak_Charging")}</h3>
                        <p>{t("Li-Ion_cars_only")}</p>
                    </Heading>
                </AccordionSummary>
                <AccordionDetails>
                    <WorkSection>
                        {PeakCharginLoader.get() && (
                            <CenteredLoader className="innerSectionLoader">
                                <Loader />
                            </CenteredLoader>
                        )}
                        <div>
                            <CheckBoxWrapper className="no-side-border mb-22">
                                <CustomizedCheckbox
                                    lockdownText="peekcharging"
                                    label={t("Enable_Off_Peak_Charging")}
                                    name="Enable Lockdown OPC"
                                    width={15}
                                    height={15}
                                    activeButtonOff={setOffPeakSaveButton}
                                    disabled={
                                        getFeatureSetOption(
                                            siteSettingsData &&
                                            siteSettingsData !== null &&
                                            siteSettingsData?.Features,
                                            getFeaturesList().real_time_tracking
                                        ) ||
                                        isUserBasic(getUserRole && getUserRole?.Role) ||
                                        isUserReadOnly(getUserRole && getUserRole?.Role)
                                    }
                                />
                            </CheckBoxWrapper>
                            <DateWrapper>
                                <StartEndDate>
                                    <p className="label">{t("Start")}</p>
                                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                                        <MobileTimePicker
                                            disabled={
                                                !enableDisablePeekChargingState.get() ||
                                                getFeatureSetOption(
                                                    siteSettingsData &&
                                                    siteSettingsData !== null &&
                                                    siteSettingsData?.Features,
                                                    getFeaturesList().real_time_tracking
                                                )
                                            }
                                            value={offPeakCharging.opcStartTime}
                                            onChange={(newValue) => {
                                                handleOpcStartTime(newValue);
                                            }}
                                            renderInput={(params) => <TextField {...params} />}
                                        />
                                    </LocalizationProvider>
                                    <TimeIcon />
                                </StartEndDate>
                                <StartEndDate>
                                    <p className="label">{t("End")}</p>
                                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                                        <MobileTimePicker
                                            disabled={
                                                !enableDisablePeekChargingState.get() ||
                                                getFeatureSetOption(
                                                    siteSettingsData &&
                                                    siteSettingsData !== null &&
                                                    siteSettingsData?.Features,
                                                    getFeaturesList().real_time_tracking
                                                )
                                            }
                                            value={offPeakCharging.opcEndTime}
                                            onChange={(newValue) => {
                                                handleOpcEndTime(newValue);
                                            }}
                                            renderInput={(params) => <TextField {...params} />}
                                        />
                                    </LocalizationProvider>
                                    <TimeIcon />
                                </StartEndDate>
                            </DateWrapper>

                            <p className="timeValidationMessage">{offPeakValidationMessage}</p>

                            <ActionWrapper>
                                <Button
                                    disabled={
                                        getFeatureSetOption(
                                            siteSettingsData &&
                                            siteSettingsData !== null &&
                                            siteSettingsData?.Features,
                                            getFeaturesList().real_time_tracking
                                        ) ||
                                        isUserBasic(getUserRole && getUserRole?.Role) ||
                                        isUserReadOnly(getUserRole && getUserRole?.Role)
                                    }
                                    style={
                                        getFeatureSetOption(
                                            siteSettingsData && siteSettingsData?.Features,
                                            getFeaturesList().real_time_tracking
                                        )
                                            ? { backgroundColor: "#d3d3d3" }
                                            : {}
                                    }
                                    onClick={handleOffPeakCharging}
                                    className={offPeakSaveButton ? "active" : "disabled"}
                                >
                                    {t("Save")}
                                </Button>
                                <Button
                                    onClick={cancelPeakChargingFunc}
                                    disabled={
                                        getFeatureSetOption(
                                            siteSettingsData &&
                                            siteSettingsData !== null &&
                                            siteSettingsData?.Features,
                                            getFeaturesList().real_time_tracking
                                        ) ||
                                        isUserBasic(getUserRole && getUserRole?.Role) ||
                                        isUserReadOnly(getUserRole && getUserRole?.Role)
                                    }
                                    style={
                                        getFeatureSetOption(
                                            siteSettingsData && siteSettingsData?.Features,
                                            getFeaturesList().real_time_tracking
                                        )
                                            ? { backgroundColor: "#d3d3d3" }
                                            : {}
                                    }
                                >
                                    {t("Cancel")}
                                </Button>
                            </ActionWrapper>
                        </div>
                        <div></div>
                        <div></div>
                        <div></div>
                    </WorkSection>
                </AccordionDetails>
            </Accordion>
        </>
    );
};